import { render, staticRenderFns } from "./PackageIdEditModal.vue?vue&type=template&id=81f1b73a&scoped=true"
import script from "./PackageIdEditModal.vue?vue&type=script&lang=js"
export * from "./PackageIdEditModal.vue?vue&type=script&lang=js"
import style0 from "./PackageIdEditModal.vue?vue&type=style&index=0&id=81f1b73a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f1b73a",
  null
  
)

export default component.exports